
import {ResourcePermissionEnum} from "./enum/resourcePermissionEnum";
import {PermissionType} from "./enum/permissionType";

export class ResourcePermission {
    public resource: string;
    public permissions: string[];
    constructor(resource: string, permissions: string[]) {
        this.resource = resource;
        this.permissions = permissions;
    }
}
